"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerType = void 0;
var ContainerType;
(function (ContainerType) {
    ContainerType["FULL_WIDTH"] = "full-width";
    ContainerType["MARGIN_AUTO"] = "margin-auto";
    ContainerType["STATIC_MARGIN"] = "static-margin";
})(ContainerType || (exports.ContainerType = ContainerType = {}));
